import { Grid, Typography } from '@material-ui/core';
import { KeyboardButton } from '@ncr-design-system/keyboard-react';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import { AppState } from 'src/common/redux/configure-store';
import { styles } from './custom-keypad-button-styles';

interface CustomKeypadButtonProps {
  children: ReactNode;
  nonNumerical?: boolean;
  disabled?: boolean;
  doubleWidth?: boolean;
  translate: 'yes' | 'no' | undefined;
  pressAction: 'add' | 'delete' | 'none';
  addValue?: string;
  deleteValue?: number | 'clear';
  buttonName: string;
  'data-testid': string;
  onClick?: () => void;
}

const CustomKeypadButton = ({
  nonNumerical = false,
  disabled,
  doubleWidth,
  children,
  ...rest
}: CustomKeypadButtonProps): JSX.Element => {
  const buttonSize = useSelector<AppState, SizeType>(
    state => state.cashierPreferences.buttonZoomLevel || 0,
  );
  const classes = styles({ doubleWidth, nonNumerical, buttonSize });
  let buttonContainer = `${classes.buttonContainer}`;
  if (disabled) {
    buttonContainer += ` disabled`;
  }

  return (
    <div className={classes.wrapper}>
      <KeyboardButton className={buttonContainer} {...rest}>
        <Grid container justifyContent='center'>
          <Typography variant='h6'>{children}</Typography>
        </Grid>
      </KeyboardButton>
    </div>
  );
};

export default React.memo(CustomKeypadButton);
